export default __webpack_public_path__ + "static/media/icon_Ethereum_white.353b08bd.svg";